<aside class="mdc-dialog" :class="classes_" :style="styles_">

    <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">

            <!-- HEADER SECTION -->
            <header class="mdc-dialog__title">
                <slot name="header"></slot>
            </header>

            <!-- BODY SECTION -->
            <section class="mdc-dialog__content">
                <slot></slot>
            </section>

            <!-- FOOTER SECTION -->
            <footer class="mdc-dialog__actions">
                <slot name="footer"></slot>
            </footer>
        </div>
    </div>

    <div class="mdc-dialog__scrim"></div>

</aside>
